import React, { useEffect, useState } from "react";
import { FaGoogle, FaFacebookF } from "react-icons/fa";
import { RiAdvertisementFill } from "react-icons/ri";
import Skeleton from "react-loading-skeleton";   // 👈 ADD THIS
import "react-loading-skeleton/dist/skeleton.css";
import { fetchAllDataAPI } from "../../utils/api";

const ReportPPCComponents = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [spendData, setSpendData] = useState(null);

    const defaultSources = [
        { key: "google", label: "Google Ads", icon: <FaGoogle /> },
        { key: "facebook", label: "Facebook Ads", icon: <FaFacebookF /> },
        { key: "others", label: "Others", icon: <RiAdvertisementFill /> },
    ];

    const sections = [
        { key: "today", label: "Today's Spend", accentClass: "border-start border-4 border-primary" },
        { key: "yesterday", label: "Yesterday's Spend", accentClass: "border-start border-4 border-success" },
        { key: "thisMonth", label: "This Month Spend", accentClass: "border-start border-4 border-warning" },
        { key: "lastMonth", label: "Last Month Spend", accentClass: "border-start border-4 border-info" },
        { key: "overall", label: "Total Spend", accentClass: "border-start border-4 border-danger" },
    ];

    useEffect(() => {
        loadSpend();
    }, []);

    const loadSpend = () => {
        setIsLoading(true);
        fetchAllDataAPI("super-admin-get-ads-spend-with-source-name")
            .then((res) => {
                if (res?.data?.status === 1) {
                    const api = res.data.data || {};

                    const formatDateLabel = (start, end) => {
                        if (!start || !end) return "";

                        const fmt = (d) => {
                            const date = new Date(d);
                            return date.toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            });
                        };

                        if (start === end) return fmt(start);
                        return `${fmt(start)} – ${fmt(end)}`;
                    };

                    const mapSec = (k) => ({
                        label: api[k]?.label || "",
                        dateLabel: formatDateLabel(api[k]?.date_start, api[k]?.date_end),
                        total: Number(api[k]?.total) || 0,
                        sources: api[k]?.sources || [],
                    });

                    setSpendData({
                        today: mapSec("today"),
                        yesterday: mapSec("yesterday"),
                        thisMonth: mapSec("this_month"),
                        lastMonth: mapSec("last_month"),
                        overall: mapSec("overall"),
                    });
                }
                setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
    };


    const formatCurrency = (v) =>
        new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 0,
        }).format(v || 0);

    const getSafeSources = (raw, total) => {
        const map = {};
        raw?.forEach((s) => {
            const key = (s.source_name || "").toLowerCase();
            map[key] = Number(s.spend) || 0;
        });

        return defaultSources.map((src) => {
            const amt = map[src.key] || 0;
            const pct = total > 0 ? ((amt / total) * 100).toFixed(1) : "0.0";
            return { ...src, amount: amt, pct };
        });
    };

    const renderCard = (section) => {
        if (isLoading || !spendData) {
            return (
                <div className="col" key={section.key}>
                    <div className="card p-3" style={{ borderRadius: 16 }}>
                        <Skeleton width={120} height={14} className="mb-2" />
                        <Skeleton width={80} height={26} className="mb-3" />
                        <Skeleton height={10} className="mb-2" />
                        <Skeleton height={10} className="mb-2" />
                        <Skeleton height={10} className="mb-2" />
                    </div>
                </div>
            );
        }

        const data = spendData[section.key];
        const safeSources = getSafeSources(data.sources, data.total);

        return (
            <div className="col" key={section.key}>
                <div className={`card shadow-sm h-100 ${section.accentClass}`} style={{ borderRadius: 16 }}>
                    <div className="p-1 d-flex flex-column h-100">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                                <h6 className="mb-0 text-uppercase">{section.label}</h6>
                                {data.dateLabel && (
                                    <small style={{ fontSize: 11, color: "#999" }}>{data.dateLabel}</small>
                                )}
                            </div>

                            <h3 style={{ fontSize: 22, fontWeight: 700 }}>
                                {formatCurrency(data.total)}
                            </h3>
                        </div>

                        {safeSources.map((src) => (
                            <div key={src.label} className="d-flex justify-content-between align-items-center mb-1">
                                <div className="d-flex align-items-center gap-2">
                                    <span
                                        className="rounded-circle d-inline-flex align-items-center justify-content-center"
                                        style={{ width: 26, height: 26, background: "#f5f5f5", fontSize: 12 }}
                                    >
                                        {src.icon}
                                    </span>
                                    <span style={{fontSize: 12}}>{src.label}</span>
                                </div>
                                <span>
                                    {formatCurrency(src.amount)} ({src.pct}%)
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="inv-component">
            <div className="row row-cols-1 row-cols-lg-5 g-3">
                {sections.map((s) => renderCard(s))}
            </div>
        </div>
    );
};

export default ReportPPCComponents;
